export function initReadMore(): void {
  document.querySelectorAll<HTMLButtonElement>('.readmore__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.getAttribute('aria-controls');
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const span = btn.querySelector('span');
      const labelOpen  = btn.dataset.labelOpen  ?? 'Mehr lesen';
      const labelClose = btn.dataset.labelClose ?? 'Weniger anzeigen';

      btn.setAttribute('aria-expanded', String(!expanded));
      target.hidden = expanded;

      if (span) {
        span.textContent = expanded ? labelOpen : labelClose;
      }

      if (!expanded) {
        target.focus();
      }
    });
  });
}
